import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthenticatedGuard } from '../../../guards/authenticated.guard';
import { SaleInformationPageComponent } from './sale-information.page';

const routes: Routes = [
  {
    canActivate: [AuthenticatedGuard],
    component: SaleInformationPageComponent,
    path: ''
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class SaleInformationPageRoutingModule {}
